import script from "./DesktopMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopMenu.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopMenu.vue?vue&type=style&index=0&id=6563910f&lang=scss"

const __exports__ = script;

export default __exports__